import { getThdProductDetails } from '../../api/thdApi';

// you do you, bro
// console.log wrapper is needed because (you guessed it) IE
const getThdProductDetailsOrNotItsCool = (skus, storeId) => (
  getThdProductDetails(skus, storeId).catch((err) => console.log(err))
);

export default getThdProductDetailsOrNotItsCool;
